import React, { useEffect, useState } from "react";
import "../styles/noteDetails.css"
import { useParams } from "react-router-dom";

export default function NoteDetails({ addToast }) {
    const { id } = useParams(); // URL-ből vesszük ki az ID-t
    const [note, setNote] = useState(null);


    //TITLE BEÁLLITÁS
    useEffect(() => {
        document.title = "Jegyzetek - FociFanatik"
    }, []);

    useEffect(() => {
        fetch("https://focifanatik.hu/api/check_login.php", {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (!data.loggedIn) {
                    window.location.href = "/regisztracio";
                }
            });
    }, []);


    useEffect(() => {
        fetch(`https://focifanatik.hu/api/get_note.php?id=${id}`)
            .then((res) => res.json())
            .then((data) => setNote(data))
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, [id]);

    if (!note) return <p className="text-center mt-5">Betöltés...</p>;

    return (
        <div className="notes-page">
            <div className="container mt-4">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-md-10">
                        {/* Fejléc kártya */}
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-body bg-primary text-white rounded-top top-card-color">
                                <div className="text-center">
                                    <h1 className="h2 mb-2 fw-bold">{note.title}</h1>
                                    {/* <span className="badge bg-light text-primary fs-6">
                                    {note.username || "Felhasználó"}
                                </span> */}
                                </div>
                            </div>
                        </div>

                        {/* Tartalom kártya */}
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-body">
                                <div className="content-section">
                                    <h5 className="text-secondary mb-3 border-bottom pb-2 text-center">Jegyzet tartalma:</h5>
                                    <div className="note-content p-3 bg-light rounded">
                                        <p className="mb-0 fs-6 lh-base" style={{ whiteSpace: 'pre-wrap' }}>
                                            {note.note}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Meta információk kártya */}
                        <div className="card shadow-sm border-0">
                            <div className="card-body">
                                <div className="text-center">
                                    <small className="text-muted">
                                        <i className="bi bi-calendar-plus me-2"></i>
                                        {note.created_at}
                                    </small>
                                </div>
                            </div>
                        </div>

                        {/* Vissza gomb */}
                        <div className="text-center mt-4">
                            <button
                                className="btn btn-outline-primary btn-lg px-4"
                                onClick={() => window.history.back()}
                            >
                                <i className="bi bi-arrow-left me-2"></i>
                                Vissza a listához
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
